// extracted by mini-css-extract-plugin
export default {"container":"Benefits_container__bcMES","overallBft":"Benefits_overallBft__08j9F","bft":"Benefits_bft__qK4dh"};